<div class="component">
  <muni-gameday-loading [visible]="!!(loading | async)">
    <span
      class="noOrders"
      [hidden]="!(emptyMessage | async)"
      [textContent]="emptyMessage | async"
      data-automation-e2e-selector="allOrdersEmptyMessagePlaceholder"
    >
    </span>
    <span
      class="noOrders"
      [hidden]="!(totalCount === 0 && !(emptyMessage | async))"
      data-automation-e2e-selector="allOrdersEmptyMessagePlaceholder"
    >
      No search results
    </span>

    <div [hidden]="!!(emptyMessage | async)" class="tableWrapper">
      <ag-grid-angular
        class="ag-theme-cupcake all-orders-table"
        [gridOptions]="gridOptions"
        [columnDefs]="columns"
        [floatingFilter]="true"
        [rowModelType]="'infinite'"
        [enableServerSideFilter]="true"
        [enableServerSideSorting]="true"
        [sortingOrder]="sortingOrder"
        [frameworkComponents]="frameworkComponents"
        [cacheBlockSize]="50"
        [floatingFiltersHeight]="33"
        [suppressRowHoverHighlight]="true"
      >
        ></ag-grid-angular
      >
    </div>
  </muni-gameday-loading>
</div>
